import React from 'react';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

import { Tabs, Tab, Paper } from '../../components/mui';
import PageTitle from '../components/PageTitle';
import Toolbar from '../../components/Toolbar';
import Loader from '../../components/Loader';
import RefreshButton from '../components/RefreshButton';
import BackButton from '../components/BackButton';
import IsosList from './components/IsosList';
import TabPanel from '../components/TabPanel';
import { messages } from './constants';
import { useIsos } from './hooks';
import { handleError } from '../../utils/handleError';
import { getSelectedIsos } from './selectors';

const { msgIsoDetails, msgTabGeneral } = messages;

const IsoDetails = () => {
    const { isoId } = useParams();

    const queryClient = useQueryClient();

    // queries
    const { data, isFetching } = useIsos({
        onError: (err) => toast.error(handleError(err)),
    });

    const selectedIsos = getSelectedIsos(data, [isoId]);

    const handleRefresh = () => {
        queryClient.invalidateQueries('isos');
    };

    return (
        <>
            <BackButton />

            <PageTitle
                primaryText={msgIsoDetails}
                secondaryText={isoId}
                noBottomMargin
            />

            <Toolbar rightContent={<RefreshButton onClick={handleRefresh} />} />

            <Paper elevation={1}>
                <Tabs value={0}>
                    <Tab label={msgTabGeneral} />
                </Tabs>

                <TabPanel value={0} index={0}>
                    <IsosList items={selectedIsos} />
                </TabPanel>
            </Paper>

            {isFetching && <Loader />}
        </>
    );
};

export default IsoDetails;
